module.exports = __webpack_public_path__ + "static/media/misha.ff59c37e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/PersonalBlock/img/misha.jpg
// module id = 128
// module chunks = 0